import { createFileRoute, Outlet, useLocation, useNavigate } from "@tanstack/react-router";
import { Tabs, Typography, Flex, Skeleton, Button, theme } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useQ_PageSettings_Organization } from "@/hooks/OrgSettings/useQ_PageSettings_Organization";

const TAB_ITEMS = [
  { key: "provider", label: "Provider" },
  { key: "api-keys", label: "API Keys" },
];

export const Route = createFileRoute("/_protected/$organizationId/$flowId/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  const { token } = theme.useToken();
  const { organizationId, flowId } = Route.useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const qOrganization = useQ_PageSettings_Organization({ organizationId });

  const activeTab = location.pathname.split("/").filter(Boolean).pop() || "provider";

  const handleTabChange = (key: string) => {
    navigate({ to: "/$organizationId/$flowId/settings/" + key as string, params: { organizationId, flowId } });
  };

  return (
    <div>
      <Flex align="center" gap={token.marginSM} style={{ marginBottom: token.marginXS }}>
        <Button
          type="text"
          icon={<ArrowLeftOutlined />}
          size="small"
          onClick={() => navigate({ to: "/$organizationId/$flowId/sessions", params: { organizationId, flowId } })}
        />
        {qOrganization.query.isLoading ? (
          <Skeleton.Input active size="small" />
        ) : (
          <Typography.Title level={3} style={{ margin: 0 }}>
            {qOrganization.organization?.name ?? "Organization"} — Settings
          </Typography.Title>
        )}
      </Flex>
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        items={TAB_ITEMS}
        style={{ marginBottom: token.marginMD }}
      />
      <Outlet />
    </div>
  );
}
